<template>
  <div class="profile-wrap" :class="{ 'loading': isProcessing }">
    <ul class="breadcrumb">
      <li>
        <router-link :to="{name: 'Home'}"><i class="el-icon-s-home"></i>Home</router-link>
      </li>
      <li>
        <router-link :to="{name: 'Dashboard'}"><i class="el-icon-s-grid"></i>Dashboard</router-link>
      </li>
      <li>
        <span>Profile</span>
      </li>
    </ul>
    <div class="organization-box">
      <h4 class="title">{{$t('TEXT_INFORMATION')}}</h4>
      <div class="flex-box">
        <div class="fields">
          <div class="field">
            <div class="field-label">{{$t('TEXT_CODE')}}</div>
            <div class="field-input">
              <el-input disabled :value="userOverview.code"></el-input>
            </div>
          </div>
          <div class="field">
            <div class="field-label">{{$t('TEXT_USERNAME')}}</div>
            <div class="field-input">
              <el-input disabled :value="userOverview.username"></el-input>
            </div>
          </div>
          <div class="field">
            <div class="field-label">{{$t('TEXT_REF_CODE')}}</div>
            <div class="field-input">
              <el-input disabled :value="userOverview.refCode"></el-input>
            </div>
          </div>
          <div class="field">
            <div class="field-label">{{$t('TEXT_TT_MEMBERS')}}</div>
            <div class="field-input">
              <el-input disabled :value="userOverview.totalMember"></el-input>
            </div>
          </div>
          <div class="field">
            <div class="field-label">Total member invest</div>
            <div class="field-input">
              <el-input disabled :value="userOverview.totalBuy"></el-input>
            </div>
          </div>
          <div class="field">
            <div class="field-label">{{ $t('TEXT_TT_COM_REF') }}</div>
            <div class="field-input">
              <el-input disabled :value="userOverview.totalComRef || 0"></el-input>
            </div>
          </div>
          <div class="field">
            <div class="field-label">{{ $t('TEXT_TT_COM_BRAND') }}</div>
            <div class="field-input">
              <el-input disabled :value="userOverview.totalComBrand || 0"></el-input>
            </div>
          </div>
          <div class="field">
            <div class="field-label">{{ $t('TEXT_TT_COM_ALEO') }}</div>
            <div class="field-input">
              <el-input disabled :value="userOverview.totalAleo || 0"></el-input>
            </div>
          </div>
          <div class="field">
            <div class="field-label">{{ $t('TEXT_TT_SALE') }}</div>
            <div class="field-input">
              <el-input disabled :value="userOverview.totalSale || 0"></el-input>
            </div>
          </div>
          <div class="field">
            <div class="field-label">Change Password</div>
            <div class="field-input">
              <el-button @click="changePassword">{{$t('BTN_CHANGE_PASSWORD')}}</el-button>
            </div>
          </div>
        </div>
        <div class="user-level" v-if="userOverview.role">
          <div class="field field-role">
            <h4>User Level: {{userOverview.role}}</h4>
            <img :src="`/assets/images/user-level/${userOverview.role.toUpperCase()}.png`" alt="Icon">
          </div>
        </div>
      </div>
    </div>

    <div class="organization-box">
      <h4 class="title">{{$t('TEXT_API_KEY')}}</h4>
      <div class="flex-box">
        <div class="fields">
          <div class="field" v-if="!user.use_two_fa">
            <div class="field-label">2FA</div>
            <div class="field-input">
              <el-button @click="enable2FA">{{$t('BTN_ENABLE_2FA')}}</el-button>
            </div>
          </div>
          <div class="field" v-else>
            <div class="field-label">2FA</div>
            <div class="field-input">
              <el-button @click="disable2FA">{{$t('BTN_DISABLE_2FA')}}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isProcessing: false
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    userOverview () {
      return this.$store.getters.userOverview
    }
  },
  created () {
  },
  methods: {
    changePassword () {
      this.$store.dispatch('toggleChangePasswordFormModal')
    },
    enable2FA () {
      this.$store.dispatch('request2FA').then(rs => {
        if (rs.status) this.$store.dispatch('toggle2FAForm', rs.data)
      })
    },
    disable2FA () {
      this.$prompt('Please enter one time code', 'Disable 2FA', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        inputPattern: /[0-9]+/
      }).then(({ value }) => {
        this.isProcessing = true
        this.$store.dispatch('disable2FA', { code: value }).then(rs => {
          if (rs) this.$store.dispatch('getUser')
        }).finally(() => {
          this.isProcessing = false
        })
      }).catch(() => {
      })
    }
  }
}
</script>
